'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var TableBody$1 = require('../../../node_modules/@material-ui/core/esm/TableBody/TableBody.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var TableBody = function TableBody(_ref) {
  var borders = _ref.borders,
      stickyColumn = _ref.stickyColumn,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ["borders", "stickyColumn", "children"]);

  return React__default["default"].createElement(TableBody$1["default"], _objectSpread({}, props), borders || stickyColumn ? React.Children.map(children, function (child) {
    return React.cloneElement(child, {
      borders: borders,
      stickyColumn: stickyColumn
    });
  }) : children);
};

module.exports = TableBody;
